import { useTranslation } from 'react-i18next';
import type { I18nNamespace } from './config';

/**
 * Strongly-typed wrapper around react-i18next's useTranslation
 * to keep namespace usage consistent across the app.
 */
export function useT(namespace: I18nNamespace = 'common') {
  return useTranslation(namespace);
}
